import { Api, IApi } from "../IApi";
import { IHttpClient } from "../IHttpClient";
import { Observable } from "rxjs/Observable";
import { Observer } from "rxjs";
import { IUser, IRole, IGroup, AccountStatus, IResult } from "../../model/ModelTypes";
import { isNullOrUndefined } from "util";
import { AxiosResponse } from "axios";
export type EditUserItem = {
    user_id?: string;
    new_name?: string;
    new_password?: string;
    new_confirmPassword?: string;
    new_role?: IRole;
    add_groups?: IGroup[];
    remove_groups?: IGroup[];
    new_status?: AccountStatus;
    is_admin?: boolean;
};
export type EditUsersRequest = {users: EditUserItem[]};
export type EditUsersResponse = {
    success: EditUsersResponseItem[];
    error: EditUsersResponseItem[];
     
};
export type EditUsersResponseItem = {
    code: number;
    message: string;
    userId: string;
};
export type DeleteUsersResponse = {
    success: DeleteUsersResponseItem[];
    error: DeleteUsersResponseItem[];
};
export type DeleteUsersResponseItem = {
    userId: string;
    message: string;
    code: string;
};
export type DeleteResultRequest = {
    userId?: string;
    courseCode?: string;
    moduleCode?: string;
    submitTime?: string;
};
export type DeleteResultResponse = {
    userId: string;
    submissions: IResult[];
};
/**
 * Defines the avialable operations for Admins in the API.
 */
export interface IAdminApi extends IApi {
    getAllUsers(): Observable<IUser[]>;
    editUsers(request: EditUsersRequest): Observable<EditUsersResponse>;
    deleteUsers(userIds: string[]): Observable<DeleteUsersResponse>;
    deleteUserResult(organisationCode: string, request: DeleteResultRequest): Observable<DeleteResultResponse>; 
    getAllResultsAsCSV(organisationCode: string): Observable<Blob>;
    exportTableDataAsCSV(headers: string[], rows: string[][]): Observable<Blob>;
    getAuthenticatedHttpClient(): IHttpClient;
    getHttpClient(): IHttpClient;
}
export class AdminApi extends Api implements IAdminApi {
    
    private organisationCode: string;
    constructor (httpClient: IHttpClient,
                 authenticatedHttpClient: IHttpClient, organisationCode: string) {
        super(httpClient, authenticatedHttpClient);
        this.organisationCode = organisationCode;
    }
    getAuthenticatedHttpClient(): IHttpClient {
        return this.authenticatedHttpClient;
    }
    getHttpClient(): IHttpClient {
        return this.httpClient;
    }
    getAllUsers(): Observable<IUser[]> {
        return Observable.create(
            (observer: Observer<IUser[]>) => {
                this.authenticatedHttpClient
                .getInstance()
                .get(`/api/organisations/${this.organisationCode.toLowerCase()}/users`)
                .then(
                    result => {
                        if (result.status === 200 && !isNullOrUndefined(result.data) 
                            && !isNullOrUndefined(result.data)) {
                            observer.next(result.data);
                            
                        } else {
                            observer.error(new Error("Something Went Wrong"));
                        }
                        return observer.complete();
                    }
                )
                .catch( error => {
                    if (!isNullOrUndefined(error) && !isNullOrUndefined(error.response)) {
                        let errorMessage = this.getGenericMessageFromError(error.response);
                        if (!isNullOrUndefined(errorMessage)) {
                            observer.error(new Error(errorMessage));
                        } else {
                            observer.error(new Error("Something Went Wrong"));
                        }
                    }
                    return observer.complete();
                }); 
            }
        );

    }
    editUsers(request: EditUsersRequest): Observable<EditUsersResponse> {
        return Observable.create(
            (observer: Observer<EditUsersResponse>) => {
                this.authenticatedHttpClient
                .getInstance()
                .put(
                    `/api/organisations/${this.organisationCode.toLowerCase()}/users`,
                    request
                )
                .then(
                    result => {
                        if (result.status === 200 && !isNullOrUndefined(result.data)) {
                            observer.next(result.data);
                        } else {
                            observer.error("Something Went Wrong");
                        }
                        return observer.complete();
                    }
                )
                .catch( error => {
                    if (!isNullOrUndefined(error) && !isNullOrUndefined(error.response)) {
                        let errorMessage = this.getGenericMessageFromError(error.response);
                        observer.error(errorMessage);
                    } else {
                        observer.error("Something Went Wrong");
                    }
                    return observer.complete();
                });
            }
        );
    }
    deleteUsers(userIds: string[]): Observable<DeleteUsersResponse> {
        return Observable.create( (observer: Observer<DeleteUsersResponse>) => {
            this
            .authenticatedHttpClient
            .getInstance()
            .delete(`/api/organisations/${this.organisationCode.toLowerCase()}/users`, {
                data: {
                    users_ids: userIds
                }
            })
            .then( response => {
                if (response.status === 200) {
                    if (!isNullOrUndefined(response.data)) {
                        observer.next(response.data);
                    } else {
                        observer.error(new Error("Something Went Wrong"));
                    }
                }
                return observer.complete();
            })
            .catch( error => {
                if (!isNullOrUndefined(error) && !isNullOrUndefined(error.response)) {
                    let errorMessage = this.getGenericMessageFromError(error.response);
                    observer.error(new Error(errorMessage));
                } else {
                    observer.error(new Error("Something Went Wrong"));
                }
                return observer.complete();
            });
        });
    }
    deleteUserResult(organisationCode: string, request: DeleteResultRequest): Observable<DeleteResultResponse> {
        return Observable.create( (observer: Observer<DeleteResultResponse>) => {
            this.authenticatedHttpClient.getInstance()
            .delete(`/api/organisations/${organisationCode.toLowerCase()}/users/results`, {
                data: request
            })
            .then( result => {
                if (result.status === 200) {
                    observer.next(result.data);
                } else {
                    observer.error(new Error(" Something Went Wrong"));
                }
                return observer.complete();
            })
            .catch( error => {
                if (!isNullOrUndefined(error) && !isNullOrUndefined(error.response)) {
                    let errorMessage = this.getGenericMessageFromError(error.response);
                    observer.error(errorMessage);
                } else {
                    observer.error("Something Went Wrong");
                }
                return observer.complete();
            });
        });
    }

    exportTableDataAsCSV(headers: string [], rows: string[][]): Observable<Blob> {
        return Observable.create( async (observer: Observer<Blob>) => {
            try {
                if (headers.length > 0 && rows.length > 0) {
                    let data =  `${headers.join(",")}\n ${rows.map(row => row.join(",")).join("\n")}`;
                    observer.next(new Blob([data] , {type: 'text/plain'}));
                } else {
                    observer.error("No results have been submitted yet!");
                }
            } catch (error) {
                observer.error(error);
            } finally {
                observer.complete();
            }
        });
    }
        getAllResultsAsCSV(organisationCode: string): Observable<Blob> {
            return Observable.create( async (observer: Observer<Blob>) => {
                try {
                    let result = await this.authenticatedHttpClient.getInstance()
                    .get(`/api/organisations/${organisationCode.toLowerCase()}/users/results?csv=true`);
                    if (result.status === 200) {
                        observer.next(new Blob([result.data.toString()] , {type: 'text/plain'}));
                    } else {
                        observer.error("Failed to Download");
                    }
                } catch (error) {
                    observer.error(error);
                } finally {
                    observer.complete();
                }

            });

        }
    private getGenericMessageFromError(error: AxiosResponse): string|undefined {
        if (!isNullOrUndefined(error.data)) {
            if (!isNullOrUndefined(error.data.error)) {
                return error.data.error;
            }   
        } 
        return undefined;
    }
}


// WEBPACK FOOTER //
// ./src/utility/admin/AdminApi.ts